<template>
  <permission-guard situation="widget_management">
    <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
    <template v-else>
      <router-link class="d-block mb-2" to="/admin/posts/widgets"
        >← ウィジェット一覧に戻る</router-link
      >
      <h2 class="headline mb-3">ウィジェット編集</h2>
      <widget-form :widget="widget" @update-widget="updateWidget" @save-widget="saveWidget" />
    </template>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import { deserialize } from 'deserialize-json-api'
import WidgetForm from './WidgetForm'
import DataLoader from '@/components/commons/DataLoader'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    PermissionGuard,
    WidgetForm,
    DataLoader
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ウィジェット編集',
      widget: {},
      fetchLoading: true
    }
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchWidget()
    this.fetchLoading = false
  },
  methods: {
    fetchWidget () {
      return axios
        .get(`/api/widgets/${this.$route.params.id}/edit`)
        .then(({ data }) => {
          this.widget = deserialize(data).data
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    saveWidget () {
      let mapWidgetPostsAttributes
      let mapWidgetTagsAttributes
      if (this.widget.mapWidgetPosts) {
        mapWidgetPostsAttributes = this.widget.mapWidgetPosts.map(
          (item) => {
            return {
              id: item.id,
              postId: item.post.id,
              _destroy: item.destroy
            }
          }
        )
      }
      if (this.widget.mapWidgetTags) {
        mapWidgetTagsAttributes = this.widget.mapWidgetTags.map(
          (item) => {
            return {
              id: item.id,
              tagId: item.tag.id,
              _destroy: item.destroy
            }
          }
        )
      }
      const widget = this.widget
      widget.mapWidgetPostsAttributes = mapWidgetPostsAttributes
      widget.mapWidgetTagsAttributes = mapWidgetTagsAttributes
      const query = { widget: widget }
      axios.patch(`/api/widgets/${this.$route.params.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.fetchWidget()
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateWidget (widget) {
      this.widget = Object.assign({}, widget)
    }
  }
}
</script>
